import { GetPatientDetailsSchema } from '@montugroup/pms-api-contracts';
import { z } from 'zod';

export const schema = GetPatientDetailsSchema.shape.medicalInfo
  .unwrap()
  .shape.attributes.pick({
    alcoholPerWeek: true,
    smoking: true,
    comments: true,
    symptoms: true,
    currentMedications: true,
    conditions: true,
    medications: true,
  })
  .partial()
  .extend({
    alcoholPerWeek: z
      .union([z.number(), z.string(), z.null()])
      .optional()
      .transform((val) => {
        if (val === '' || val === null || val === undefined) {
          return 0;
        }
        return typeof val === 'string' ? Number(val) : val;
      })
      .nullable()
      .refine((val) => val === null || val >= 0, {
        message: 'Must be a positive number',
      }),
  });

export type FormFields = z.infer<typeof schema>;
